export class ListingCategories {
	public static readonly CUSTOMIZED_MODEL_PORTFOLIO = 'CUSTOMIZED_MODEL_PORTFOLIO';
	public static readonly MODEL_PORTFOLIO = 'MODEL_PORTFOLIO';
	public static readonly USER_PORTFOLIO = 'USER_PORTFOLIO';
	public static readonly USER_TAX_LIST = 'USER_TAX_LIST';
	public static readonly UNKNOWN = 'UNKNOWN';
	public static readonly SAMPLE = 'Sample';
}

export class PortfolioStructure {
	public static readonly HOLDINGS_ONLY_PORTFOLIOS = 'HOLDINGS_ONLY_PORTFOLIOS';
	public static readonly BLENDED_PORTFOLIOS = 'BLENDED_PORTFOLIOS';
	public static readonly HOLDINGS_ONLY_PORTFOLIOS_DESC = 'HOLDINGS_ONLY_PORTFOLIOS_DESC';
	public static readonly BLENDED_PORTFOLIOS_DESC = 'BLENDED_PORTFOLIOS_DESC';
}
